<div style="background-color: #161A29">

  <div id="imageContainer" class="divContainer">
    <canvas id="canvasSurface" class="divContainer" #canvas></canvas>
  </div>

  @if (this.data.isExpert) {
    <div class="buttons-area" #editImgContainer>
      <div class="round-button close-button" (click)="close()" #editImgButton>
        <img src="/assets/images/buttons/close.svg" alt="Icono">
      </div>
      @if (!tempHidden) {
        <div class="round-button capture-tool-button pencil" #editImgButton>
          <img src="/assets/images/buttons/capture/arrow.svg" alt="arrow" title="arrow">
        </div>
      }
      @if (this.editorMode != EDITOR_CONSTANTS.ImageReceived) {
        <div class="round-button capture-tool-button" (click)="drawSquare()" #editImgButton>
          <img src="/assets/images/buttons/capture/shape.svg" alt="shape" title="shape">
        </div>
      }
      @if (this.editorMode != EDITOR_CONSTANTS.ImageReceived) {
        <div class="round-button capture-tool-button" #editImgButton>
          <img src="/assets/images/buttons/capture/text.svg" alt="text" title="text" (click)="writeText()">
        </div>
      }
      @if (this.editorMode != EDITOR_CONSTANTS.ImageReceived) {
        <div class="round-button capture-tool-button"
          [ngClass]="{'button-active' : this.isLiveStrokeDraw}" #editImgButton>
          <img src="/assets/images/buttons/capture/pencil.svg" alt="pencil" title="pencil" (click)="freeDrawing(null)">
        </div>
      }
      @if (this.editorMode != EDITOR_CONSTANTS.ImageReceived) {
        <div class="round-button capture-tool-button" #editImgButton>
          <input type="color" value="{{startUpColor}}" (change)="updateColor($event)" />
          <img src="/assets/images/buttons/capture/colours.svg" alt="colours" title="colours">
        </div>
      }
      @if (this.editorMode != EDITOR_CONSTANTS.ImageReceived) {
        <div class="round-button capture-tool-button" #editImgButton>
          <img src="/assets/images/buttons/capture/eraser.svg" alt="eraser" title="eraser" (click)="eraseAll()">
        </div>
      }
      @if (inCall) {
        <div class="round-button capture-tool-button" [ngClass]="{'button-active': this.editorMode === EDITOR_CONSTANTS.LiveDraw}" #editImgButton>
          <img src="/assets/images/buttons/capture/live.svg" alt="live" title="live" (click)="startLiveDraw();">
        </div>
      }
      @if (showSaveButton) {
        <div class="round-button capture-tool-button" #editImgButton>
          <img src="/assets/images/buttons/capture/save.svg" alt="save" title="save" (click)="saveAndClose(false)">
        </div>
      }
      <div class="round-button capture-tool-button" #editImgButton>
        <img src="/assets/images/buttons/capture/send.svg" alt="send" title="send" (click)="saveAndClose(true)">
      </div>
    </div>
  }
</div>
